document.addEventListener('DOMContentLoaded', function() {
    // Vybereme všechny tlačítka
    const buttons = document.querySelectorAll('.custom-btn');

    buttons.forEach(button => {
        const arrow = button.querySelector('.btn-arrow');
        const text = button.querySelector('.btn-text');

        // Získáme šířky prvků
        const buttonWidth = button.offsetWidth; // Šířka celého tlačítka
        const arrowWidth = arrow.offsetWidth;  // Šířka šipky
        const textWidth = text.offsetWidth;    // Šířka textu

        button.addEventListener('mouseenter', () => {
            // Při hoveru se šipka posune doleva o šířku tlačítka a text o šířku šipky
            arrow.style.transform = `translateX(-${buttonWidth - arrowWidth}px) rotate(-360deg)`; // Posuneme šipku doleva
            text.style.transform = `translateX(${arrowWidth}px)`; // Posuneme text doprava
            arrow.style.zIndex = '500'; // Zajistíme, že šipka bude nad textem
            arrow.classList.replace('fa-chevron-left', 'fa-chevron-right');
            arrow.style.padding = '14px 5px 0 0';
        });

        button.addEventListener('mouseleave', () => {
            // Při opuštění hoveru se vrátíme zpět na původní pozici
            arrow.style.transform = `translateX(0) rotate(0deg)`; // Vrať šipku zpět
            text.style.transform = `translateX(0)`;  // Vrať text zpět
            arrow.style.zIndex = '500'; // Resetujeme z-index, aby šipka byla správně
            arrow.classList.replace('fa-chevron-right', 'fa-chevron-left');
            arrow.style.padding = '14px 0 0 5px';

        });
    });
});